module.exports = __webpack_public_path__ + "Pledge_10.ca2c4996.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/graphics/Pledge_10.png
// module id = thm3
// module chunks = 0